import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { HorizonEventTemplateRequestsModule } from '@/modules/horizon/event-template-requests/horizon-event-template-requests-module';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

/** URL search params: list filters + view (which request detail is open). All optional except defaults. */
const searchSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().default(10),
  search: z.string().optional(),
  category: z.string().optional(),
  view: z.string().optional(),
  viewKey: z.coerce.number().optional(),
  reject: z.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/horizon/event-templates/requests/'
)({
  validateSearch: searchSchema,
  component: HorizonEventTemplateRequestsPage,
});

function HorizonEventTemplateRequestsPage() {
  const { canAccessHorizonTemplateRequests } = useAccessControl();

  if (!canAccessHorizonTemplateRequests) {
    return <AccessDenied />;
  }

  return <HorizonEventTemplateRequestsModule />;
}
